export default __webpack_public_path__ + "static/media/Heros.8a64aa61.jpg";